import { render } from "./AdBanners.vue?vue&type=template&id=be3618ee&scoped=true"
import script from "./AdBanners.vue?vue&type=script&lang=js"
export * from "./AdBanners.vue?vue&type=script&lang=js"

import "./AdBanners.vue?vue&type=style&index=0&id=be3618ee&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-be3618ee"]])

export default __exports__